export default __webpack_public_path__ + "static/media/nft-21.cc0e66ba.png";